import { EOsdType } from "../constants";
import {
  CreateDynamicSchema,
  EmailRegex,
  FieldConfig,
  OPTION_MSG,
  REQUIRED_MSG,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [
  RequiredField("exceptionType"),
  RequiredField("proNumber"),
  RequiredField("lastTrailerNumber", "", false),
  RequiredField("lastManifestNumber", REQUIRED_MSG, true, "number"),
  RequiredField("pieces", REQUIRED_MSG, true, "number"),
  RequiredField("weight", REQUIRED_MSG, true, "number"),
  RequiredField("commodityCode", "Required field: Please select a value"),
  RequiredField("commodityDescription"),
  RequiredField("storageChargeStartDate", "Required field: Please select a date"),
  RequiredField("damagePhotoAndNotes", REQUIRED_MSG, true, "string", false, 150, "Maximum 150 characters allowed"),
  RequiredField("refusalReason", REQUIRED_MSG, true, "string", false, 150, "Maximum 150 characters allowed"),
  RequiredField("isShipmentVisiblyDamaged", OPTION_MSG),
  RequiredField("copiesToPrint", REQUIRED_MSG, false, "number"),

  {
    name: "partyDetails",
    type: "array",
    schema: [
      {
        name: "partyEmail",
        type: "string",
        required: true,
        message: REQUIRED_MSG,
        matches: EmailRegex,
        matchesMessage: "Invalid Email Address",
        isUnique: true,
      },
      RequiredField("partyFax", "", false),
    ],
  },
  RequiredField("replyToTerminalNumber", "Required field: Please select a value"),
  RequiredField("replyToPhoneNumber", REQUIRED_MSG, true, "number"),
  RequiredField("replyToAddress1","", false),
  RequiredField("replyToAddress2", "", false),
  RequiredField("replyToCity","", false),
  RequiredField("replyToState", "", false),
  RequiredField("replyToZip","", false),
  RequiredField("replyToAttention"),
  RequiredField("replyToFaxNumber", REQUIRED_MSG, true, "number"),
];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const OnHandSchema = CreateDynamicSchema(config);

export const InitOnHandFormValue = {
  exceptionType: EOsdType.oh,
  exceptionNumber: "",
  proNumber: "",
  pieces: "",
  weight: "",
  commodityCode: "",
  commodityDescription:"",
  storageChargeStartDate: "",
  partyDetails: [{ partyEmail: "", partyFax: "" }],
  replyToTerminalNumber: "",
  replyToPhoneNumber: "",
  replyToAddress1: "",
  replyToAddress2: "",
  replyToCity: "",
  replyToState: "",
  replyToZip: "",
  replyToAttention: "",
  replyToFaxNumber: "",
  damagePhotoAndNotes: "",
  refusalReason: "",
  isShipmentVisiblyDamaged: "",
  lastManifestNumber: "",
  lastTrailerNumber: "",
  copiesToPrint:""
};
